export default "/images/8c54e975ab66d30ffa99add1a7d5cedb.avif";